<section
    class="advance-booking-banner"
    (click)="onClickAllBanner($event)">
    <div
        [ngClass]="isLargeBanner ? 'halfcircle--large' : 'halfcircle--small'"
        [ngStyle]="backgroundStyle.halfCircle">
    </div>
    <div
        class="banner"
        [ngStyle]="backgroundStyle.banner"
        [style.cursor]="cursorDefault ? 'default': 'pointer'"
        [ngClass]="isLargeBanner ? 'banner--large' : 'banner--small'">
        <div class="logo--mobile" *ngIf="!isLargeBanner">
            <div
                class="logo_img"
                [ngStyle]="{
                    'background': 'url(' + imageLogo + ') no-repeat center / contain'
                }">
            </div>
        </div>
        <div class="logo-text">
            <div class="logo">
                <div
                    class="logo_img"
                    [ngStyle]="{
                        'background': 'url(' + imageLogo + ') no-repeat center / contain'
                    }">
                </div>
            </div>
            <div class="text-banner">
                <h2 class="text-banner__title">
                    {{ bannerTitle }}
                </h2>
                <span class="text-banner__subtitle" *ngIf="isLargeBanner">
                    {{ bannerSubTitle }}
                </span>
                <button
                    class="banner-link banner-link--mobile"
                    role="link"
                    *ngIf="!isLargeBanner">
                    <div class="banner-links">
                        <span class="banner-link__text">{{linkText}}</span>
                    </div>
                    <span class="di di-next di-icon-right" aria-hidden="true"></span>
                </button>
            </div>
        </div>
        <div class="banner-button-wrapper" [style]="starStyle">
            <wdpr-button
                *ngIf="isLargeBanner"
                [id]="buttonId"
                class="banner-button"
                theme="reversed"
                size="mini">
                <span>{{ buttonText }}</span>
            </wdpr-button>
        </div>
        <button class="banner-link" role="link" *ngIf="!isLargeBanner">
            <div class="banner-link">
                <span class="banner-link__text">{{ linkText }}</span>
            </div>
            <span class="di di-next di-icon-right" aria-hidden="true"></span>
        </button>
    </div>
</section>
